// extracted by mini-css-extract-plugin
export default {"autoRenewIMG":"caY_36MLq","renewWrap":"cmHUZaZGT"};